import { InsightsReportKey } from './enums/insights-report-key';
import { InsightsReportConfigs, InsightsReportPath } from './insights.constants';

export const getInsightsReportPath = (key: InsightsReportKey) => {
  return [`/${InsightsReportPath}`].concat(InsightsReportConfigs[key].path);
};
